/** опыт для достижения уровня: индекс — уровень минус один */
export const EXPERIENCE_BY_LEVEL = [
	0, 300, 900, 2700, 6500, 14000, 23000, 34000, 48000, 64000, 85000, 100000, 120000, 140000, 165000, 195000, 225000,
	265000, 305000, 355000,
];

/** опыт, нужный для следующего уровня; на последнем уровне — undefined */
export const nextLevelExperience = (level: number): number | undefined => EXPERIENCE_BY_LEVEL[level];

/** уровень, которого персонаж достигает с этим опытом */
export const levelForExperience = (experience: number): number =>
	EXPERIENCE_BY_LEVEL.filter((threshold) => experience >= threshold).length;
